module.exports = __webpack_public_path__ + "static/media/loading.b8613f3c.gif";